<template>
  <div>
    <div class="search">
      <el-form :model="queryParams" ref="queryForm">
        <div class="form-box">
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入名称"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </div>
      </el-form>
      <div>
        <a href="javascript:;" class="btn btn-search" @click="handleQuery">
          <img src="../../../../assets/tableImg/search.svg" alt="" />{{ $t('search.search') }}</a
        >
        <a href="javascript:;" class="btn btn-reset" @click="resetQuery">
          <img src="../../../../assets/tableImg/reset.svg" alt="" />{{ $t('search.reset') }}</a
        >
      </div>
    </div>

    <div class="content-box">
      <div>
        <buttonItem :buttonList="menuButtonList" @chooseClick="handleDelete"></buttonItem>
      </div>

      <el-table
        v-loading="loading"
        :data="finishedList"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column
          label="审批流程类型"
          align="center"
          prop="entityTypeName"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="业务编码"
          align="center"
          prop="entityCode"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="任务节点" align="center" prop="taskName" />
        <el-table-column label="操作类型" align="center">
          <template slot-scope="scope">
            <label>{{ scope.row.actionName }}</label>
          </template>
        </el-table-column>
        <el-table-column label="操作人" align="center" prop="assigneeName" width="180" />
        <el-table-column
          label="操作意见"
          align="center"
          prop="commentString"
          width="180"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="发起时间" align="center" prop="createTime" width="180" />
        <el-table-column label="完成时间" align="center" prop="finishTime" width="180" />
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-tickets"
              @click="handleFlowRecord(scope.row)"
              >流转记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :multipleSelection="ids"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      ></pagination>
    </div>
  </div>
</template>

<script>
  import pagination from '../../../../components/pagination';
  import buttonItem from '../../../../components/ButtonItem';

  export default {
    name: 'Deploy',
    components: {
      pagination,
      buttonItem,
    },
    data() {
      return {
        // 遮罩层
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        // 显示搜索条件
        showSearch: true,
        // 总条数
        total: 0,
        // 已办任务列表数据
        finishedList: [],
        // 弹出层标题
        title: '',
        // 是否显示弹出层
        open: false,
        src: '',
        // 查询参数
        queryParams: {
          pageNum: 1,
          pageSize: 10,
          name: null,
          category: null,
          key: null,
          tenantId: null,
          derivedFrom: null,
          derivedFromRoot: null,
          parentDeploymentId: null,
          engineVersion: null,
        },
        // 表单参数
        form: {},
        // 表单校验
        rules: {},
        menuButtonList: [],
      };
    },
    created() {
      this.getList();
      this.getButtons().then((e) => {
        this.menuButtonList = e;
      });
    },
    methods: {
      /** 查询流程定义列表 */
      getList() {
        this.loading = true;
        this.$axios
          .post('/maindata/flowable/task/listDoneByPage', this.queryParams)
          .then((response) => {
            this.finishedList = response.data.data.list;
            this.total = response.data.data.total;
            this.loading = false;
          });
      },
      // 取消按钮
      cancel() {
        this.open = false;
        this.reset();
      },
      // 表单重置
      reset() {
        this.form = {
          id: null,
          name: null,
          category: null,
          key: null,
          tenantId: null,
          derivedFrom: null,
          derivedFromRoot: null,
          parentDeploymentId: null,
          engineVersion: null,
        };
        this.resetForm('form');
      },
      setIcon(val) {
        if (val) {
          return 'el-icon-check';
        } else {
          return 'el-icon-time';
        }
      },
      setColor(val) {
        if (val) {
          return '#2bc418';
        } else {
          return '#b3bdbb';
        }
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParams.pageNum = 1;
        this.getList();
      },
      /** 重置按钮操作 */
      resetQuery() {
        this.resetForm('queryForm');
        this.handleQuery();
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
        this.ids = selection.map((item) => item.id);
        this.single = selection.length !== 1;
        this.multiple = !selection.length;
      },
      /** 新增按钮操作 */
      handleAdd() {
        this.reset();
        this.open = true;
        this.title = '添加流程定义';
      },
      /** 流程流转记录 */
      handleFlowRecord(row) {
        this.$router.push({
          path: '/flowable/record',
          query: {
            procInsId: row.procInsId,
            deployId: row.deployId,
            taskId: row.taskId,
          },
        });
      },
      /** 撤回任务 */
      handleRevoke(row) {
        const params = {
          instanceId: row.procInsId,
        };
        this.$axios.post('/maindata/flowable/task/revokeProcess', params).then((res) => {
          this.$message({ showClose: true, message: res.data.msg, type: 'success' });
          this.getList();
        });
      },
      /** 修改按钮操作 */
      handleUpdate(row) {
        this.reset();
        const id = row.id || this.ids;
        this.getDeployment(id).then((response) => {
          this.form = response.data;
          this.open = true;
          this.title = '修改流程定义';
        });
      },
      /** 提交按钮 */
      submitForm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.form.id != null) {
              this.updateDeployment(this.form).then(() => {
                this.msgSuccess('修改成功');
                this.open = false;
                this.getList();
              });
            } else {
              this.addDeployment(this.form).then(() => {
                this.msgSuccess('新增成功');
                this.open = false;
                this.getList();
              });
            }
          }
        });
      },
      /** 删除按钮操作 */
      handleDelete(row) {
        const ids = row.id || this.ids;
        this.$confirm('是否确认删除流程定义编号为"' + ids + '"的数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$axios.delete(`/maindata/system/deployment/${ids}`);
            this.getList();
            this.msgSuccess('删除成功');
          })
          .catch(() => {});
      },
      /** 导出按钮操作 */
      handleExport() {
        const queryParams = this.queryParams;
        this.$confirm('是否确认导出所有流程定义数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(function () {
            return this.exportDeployment(queryParams);
          })
          .then((response) => {
            this.download(response.msg);
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  .search {
    margin-bottom: 10px;
    padding: 0 30px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .form-box {
      display: flex;
      .el-form-item {
        width: 320px;
        margin-left: 20px;
        margin-top: 18px;
        ::v-deep .el-form-item__label {
          width: 80px;
        }
        ::v-deep .el-form-item__content {
          margin-left: 80px;
        }
        ::v-deep .el-select {
          width: 100%;
        }
        ::v-deep .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 100%;
        }
      }
      .item {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .btn {
      width: 90px;
      height: 30px;
      display: inline-block;
      line-height: 30px;
      text-align: center;
      border-radius: 3px;
      img {
        vertical-align: middle;
        padding-right: 10px;
      }
    }

    .btn-search {
      background-color: #409eff;
      color: #ffffff;
    }
    .btn-reset {
      background-color: #ffffff;
      color: #409eff;
      border: 1px solid #e4e6eb;
    }
  }

  .content-box {
    padding: 20px 30px;
    background-color: #ffffff;
  }

  ::v-deep .el-button--text {
    color: #00b400;
  }
</style>
